import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Locale } from './types';

export interface Translations {
  appName: string;
  appBadge: string;
  clubName: string;
  sponsorName: string;
  alumniAlliance: string;
  tabArena: string;
  tabBaodian: string;
  tabUmpire: string;
  tabStudio: string;
  tabAcademy: string;
  tabNtrp: string;
  tabCustomizer: string;
  coachAdvice: string;
  shotRecommendation: string;
  wardlawLaw: string;
  netClearance: string;
  speed: string;
  successRate: string;
  singlesMode: string;
  doublesMode: string;
  dragBallTip: string;
  changeCourtTheme: string;
  umpireTitle: string;
  pointP1: string;
  pointP2: string;
  undo: string;
  resetMatch: string;
  deuce: string;
  breakPoint: string;
  set: string;
  matchOver: string;
  diagnosticStudio: string;
  strokeSelector: string;
  symptomSelector: string;
  kineticChain: string;
  rootCause: string;
  proCue: string;
  correctiveDrills: string;
  ntrpAssessment: string;
  startQuiz: string;
  myRank: string;
  syncCode: string;
  wechatShare: string;
  copySuccess: string;
}

const translations: Record<Locale, Translations> = {
  zh_cn: {
    appName: '欢乐网球 AI 教练',
    appBadge: 'AI Pro PWA',
    clubName: '欢乐网球俱乐部 (Joy Tennis Club)',
    sponsorName: '唯爱AI公益基金会',
    alumniAlliance: '北美高校联盟 网球俱乐部',
    tabArena: '战术沙盘',
    tabBaodian: '实战宝典',
    tabUmpire: '比赛裁判',
    tabStudio: '动作纠错',
    tabAcademy: '网球学苑',
    tabNtrp: 'NTRP评测',
    tabCustomizer: '场地与装备',
    coachAdvice: 'AI教练实时支招',
    shotRecommendation: '最佳击球路线推荐',
    wardlawLaw: '沃德洛战术法则',
    netClearance: '建议过网高度',
    speed: '建议球速',
    successRate: '理论胜率与容错率',
    singlesMode: '单打战术模式',
    doublesMode: '双打战术模式',
    dragBallTip: '提示：在球场上轻触或拖动网球，AI教练将即时推演最佳击球策略！',
    changeCourtTheme: '切换球场材质',
    umpireTitle: '实战计分裁判席',
    pointP1: '选手1 得分',
    pointP2: '选手2 得分',
    undo: '撤销上一分',
    resetMatch: '重置比赛',
    deuce: '平分 (Deuce)',
    breakPoint: '破发点！',
    set: '盘',
    matchOver: '比赛结束',
    diagnosticStudio: 'AI 球技与动力链纠错工坊',
    strokeSelector: '选择击球技术环节',
    symptomSelector: '选择出现的失误症状',
    kineticChain: '动力链薄弱环节',
    rootCause: '动作缺陷深度成因',
    proCue: '职业大师标杆示范',
    correctiveDrills: '定制化纠错特训方案',
    ntrpAssessment: 'NTRP 战力等级官方评测',
    startQuiz: '开始 4 步评测',
    myRank: '我的俱乐部段位',
    syncCode: '6位免密同步码',
    wechatShare: '一键复制微信朋友圈与群分享',
    copySuccess: '已成功复制到剪贴板！',
  },
  zh_tw: {
    appName: '歡樂網球 AI 教練',
    appBadge: 'AI Pro PWA',
    clubName: '歡樂網球俱樂部 (Joy Tennis Club)',
    sponsorName: '唯愛AI公益基金會',
    alumniAlliance: '北美高校聯盟 網球俱樂部',
    tabArena: '戰術沙盤',
    tabBaodian: '實戰寶典',
    tabUmpire: '比賽裁判',
    tabStudio: '動作糾錯',
    tabAcademy: '網球學苑',
    tabNtrp: 'NTRP評測',
    tabCustomizer: '場地與裝備',
    coachAdvice: 'AI教練即時支招',
    shotRecommendation: '最佳擊球路線推薦',
    wardlawLaw: '沃德洛戰術法則',
    netClearance: '建議過網高度',
    speed: '建議球速',
    successRate: '理論勝率與容錯率',
    singlesMode: '單打戰術模式',
    doublesMode: '雙打戰術模式',
    dragBallTip: '提示：在球場上輕觸或拖動網球，AI教練將即時推演最佳擊球策略！',
    changeCourtTheme: '切換球場材質',
    umpireTitle: '實戰計分裁判席',
    pointP1: '選手1 得分',
    pointP2: '選手2 得分',
    undo: '撤銷上一分',
    resetMatch: '重置比賽',
    deuce: '平分 (Deuce)',
    breakPoint: '破發點！',
    set: '盤',
    matchOver: '比賽結束',
    diagnosticStudio: 'AI 球技與動力鏈糾錯工坊',
    strokeSelector: '選擇擊球技術環節',
    symptomSelector: '選擇出現的失誤症狀',
    kineticChain: '動力鏈薄弱環節',
    rootCause: '動作缺陷深度成因',
    proCue: '職業大師標桿示範',
    correctiveDrills: '客製化糾錯特訓方案',
    ntrpAssessment: 'NTRP 戰力等級官方評測',
    startQuiz: '開始 4 步評測',
    myRank: '我的俱樂部段位',
    syncCode: '6位免密同步碼',
    wechatShare: '一鍵複製微信朋友圈與群分享',
    copySuccess: '已成功複製到剪貼簿！',
  },
  en: {
    appName: 'Joy Tennis AI Coach',
    appBadge: 'AI Pro PWA',
    clubName: 'Joy Tennis Club',
    sponsorName: 'VI AI for Good Foundation',
    alumniAlliance: 'North America Chinese University Alumni Tennis Alliance',
    tabArena: 'Court Arena',
    tabBaodian: 'Strategy Bible',
    tabUmpire: 'Match Umpire',
    tabStudio: 'AI Diagnostic',
    tabAcademy: 'Academy',
    tabNtrp: 'NTRP Rating',
    tabCustomizer: 'Gear & Court',
    coachAdvice: 'AI Coach Real-time Guidance',
    shotRecommendation: 'Recommended Tactical Shot',
    wardlawLaw: 'Wardlaw Directional Law',
    netClearance: 'Net Clearance Margin',
    speed: 'Target Pace',
    successRate: 'Success Probability',
    singlesMode: 'Singles Strategy',
    doublesMode: 'Doubles Strategy',
    dragBallTip: 'Tip: Tap or drag the tennis ball on the court to calculate optimal shot tactics!',
    changeCourtTheme: 'Switch Court Surface',
    umpireTitle: 'Live Match Umpire & Tracker',
    pointP1: 'Player 1 Point',
    pointP2: 'Player 2 Point',
    undo: 'Undo Last Point',
    resetMatch: 'Reset Match',
    deuce: 'Deuce',
    breakPoint: 'Break Point!',
    set: 'Set',
    matchOver: 'Match Over',
    diagnosticStudio: 'AI Biomechanics & Fault Studio',
    strokeSelector: 'Select Stroke Type',
    symptomSelector: 'Select Error Symptom',
    kineticChain: 'Kinetic Chain Breakdown',
    rootCause: 'Root Cause Analysis',
    proCue: 'Pro Player Reference',
    correctiveDrills: 'Prescribed Corrective Drills',
    ntrpAssessment: 'Official NTRP Rating Quiz',
    startQuiz: 'Take 4-Step Quiz',
    myRank: 'Club Rank & EXP',
    syncCode: '6-Digit Cloud Sync Code',
    wechatShare: 'Copy for WeChat & Social Share',
    copySuccess: 'Copied to clipboard successfully!',
  }
};

interface I18nContextType {
  locale: Locale;
  setLocale: (l: Locale) => void;
  t: Translations;
}

const I18nContext = createContext<I18nContextType | null>(null);

export const I18nProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [locale, setLocale] = useState<Locale>(() => {
    const saved = localStorage.getItem('joy_tennis_locale') as Locale;
    return saved || 'zh_cn';
  });

  const handleSetLocale = (newLocale: Locale) => {
    setLocale(newLocale);
    localStorage.setItem('joy_tennis_locale', newLocale);
  };

  return (
    <I18nContext.Provider value={{ locale, setLocale: handleSetLocale, t: translations[locale] }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within an I18nProvider');
  return ctx;
};
